import { AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';
import { SimService } from '@sales/services/sim.service';
import { SimCard, SimCardType } from '../models/simcard.model';
import { updateFormAfterAsyncValidation } from '@app/core/utils';

export function SimCardValidator(
  simService: SimService,
  correctSimCardType: SimCardType,
  onCompleteCallback: () => void = null
): AsyncValidatorFn {
  return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    return timer(500).pipe(
      switchMap(() => {
        return simService.simCard(control.value).pipe(
          map((response: SimCard) => {
            if (!response.isAvailable && response.type !== correctSimCardType) {
              return {
                simCardInUse: true,
                simCardTypeInvalid: true,
              };
            }

            if (!response.isAvailable) {
              return { simCardInUse: true };
            }

            if (response.type !== correctSimCardType) {
              return { simCardTypeInvalid: true };
            }
            return null;
          }),
          catchError(() => of({ apiException: true })),
          finalize(() => {
            updateFormAfterAsyncValidation(control);

            if (onCompleteCallback) {
              onCompleteCallback();
            }
          })
        );
      })
    );
  };
}
